import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http'
import {inject} from '@angular/core'
import {catchError, filter, mergeMap, switchMap, take, throwError} from 'rxjs'
import {BASE_URL} from '../config'
import {AuthService, TokenService} from '../services'

let isRefreshing = false

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService)
    const tokenService = inject(TokenService)

    const isApiUrl = req.url.startsWith(BASE_URL)
   const isLoginUrl = req.url.includes(`${BASE_URL}/auth/login`)



    if (isApiUrl && !isLoginUrl) {
        return handleAPIRequest(req, next, authService, tokenService)
    }

    return next(req)
}

const handleRefreshTokenRequest = (request: HttpRequest<unknown>, next: HttpHandlerFn, tokenService: TokenService) => {
    request = request.clone({
        setHeaders: {Authorization: `Bearer ${tokenService.$$refreshToken()}`},
    })

    return next(request)
}

const handleExchangeFirebaseToken = (request: HttpRequest<unknown>, next: HttpHandlerFn, tokenService: TokenService) => {
    request = request.clone({
        setHeaders: {Authorization: `Bearer ${tokenService.$$firebaseToken()}`},
    })

    return next(request)
}

const handleAPIRequest = (request: HttpRequest<unknown>, next: HttpHandlerFn, authService: AuthService, tokenService: TokenService) => {
    let token = tokenService.$$accessToken()
    const tokenParam = new URL(window.location.href).searchParams.get('token')
    if (tokenParam) token = tokenParam

    request = request.clone({
        setHeaders: {Authorization: `Bearer ${token}`},
    })

    return next(request).pipe(
        catchError((error) => {
            return handleAPIRequestError(error, request, next, authService, tokenService)
        })
    )
}

const handleAPIRequestError = (
    error: unknown,
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
    authService: AuthService,
    tokenService: TokenService
) => {
    // TODO: Remove the 403 once the backend supports 401
    if (error instanceof HttpErrorResponse && error.status === 401) {
        return handleTokenExpiration(request, next, authService, tokenService)
    }
    return throwError(() => error)
}

const handleTokenExpiration = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
    authService: AuthService,
    tokenService: TokenService
) => {
    if (!isRefreshing) {
        isRefreshing = true
        tokenService.setRefreshStatus(true)

        return authService.refreshToken().pipe(
            mergeMap(() => {
                isRefreshing = false
                tokenService.setRefreshStatus(false)

                request = request.clone({
                    setHeaders: {Authorization: `Bearer ${tokenService.$$accessToken()}`},
                })

                return next(request)
            }),
            catchError((err) => {
                isRefreshing = false
                tokenService.setRefreshStatus(false)
                // Auto-navigation disabled: don't redirect to login/logout on a
                // failed refresh — just let the app stay on the current page.
                // authService.redirectToLogin(window.location.href)

                return throwError(() => err)
            })
        )
    }

    return tokenService.accessToken$.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => {
            request = request.clone({
                setHeaders: {Authorization: `Bearer ${token}`},
            })
            return next(request)
        })
    )
}
